// @flow

import createAuthenticationResource from './resources/createAuthenticationResource'
import createMedicineResource from './resources/createMedicineResource'
import createMedicineInfoResource from './resources/createMedicineInfoResource'
import createFooterResource from './resources/createFooterResource'
import createSettingsResource from './resources/createSettingsResource'

import HttpError from './HttpError'

type RequestHeaders = {[key: string]: string}

type RequestParams = $Shape<{
  endpoint: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  body?: any,
  headers?: RequestHeaders
}>

class ApiClient {
  baseUrl: string
  resources: typeof $Resources

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
    this.resources = createResources(baseUrl, this)
  }

  get = ({endpoint, headers = {}}: RequestParams): Promise<mixed> =>
    this.request({method: 'GET', endpoint, headers});

  post = ({endpoint, body, headers = {}}: RequestParams): Promise<mixed> =>
    this.request({
      method: 'POST',
      endpoint,
      body: convertBodyByContentType(body, headers['Content-Type']),
      headers,
    })

  delete = ({endpoint, body, headers = {}}: RequestParams): Promise<mixed> =>
    this.request({
      method: 'DELETE',
      endpoint,
      body: convertBodyByContentType(body, headers['Content-Type']),
      headers,
    })

  put = ({endpoint, body, headers = {}}: RequestParams): Promise<mixed> =>
    this.request({
      method: 'PUT',
      endpoint,
      body: convertBodyByContentType(body, headers['Content-Type']),
      headers,
    })

  destroy = ({endpoint, headers}: RequestParams): Promise<mixed> =>
    this.request({method: 'DELETE', endpoint, headers})

  request = ({
    method,
    endpoint,
    body,
    headers = {},
  }: RequestParams): Promise<mixed> => {
    const params: any = {
      method,
      mode: 'cors',
      headers: {
        ...getDefaultHeaders(),
        ...headers,
      },
    }

    if (headers['Content-Type'] === 'multipart/form-data') {
      delete params.headers['Content-Type']
    }

    if (body) {
      params.body = body
    }

    return new Promise((resolve, reject) => {
      fetch(`${this.baseUrl}${endpoint}`, params)
        .then(response => ({
          json: response.json(),
          status: response.status,
        }))
        .then(({json, status}) => {
          if ([401, 403, 400, 404, 402, 422, 429, 500].indexOf(status) !== -1) {
            return reject(new HttpError(status, json))
          }

          return resolve(json)
        })
    })
  }
}

const getDefaultHeaders = (): RequestHeaders => {
  let token = localStorage.getItem('token')
  if (!token) {
    token = ''
  }
  const headers: RequestHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  }

  return headers
}

const createResources = (baseUrl: string, api: ApiClient) => ({
  authentication: createAuthenticationResource(baseUrl, api),
  medicine: createMedicineResource(baseUrl, api),
  medicineinfo: createMedicineInfoResource(baseUrl, api),
  footer: createFooterResource(baseUrl, api),
  settings: createSettingsResource(baseUrl, api),
})

const $Resources = createResources('http://www.example.com', ({}: any))

const convertBodyByContentType = (body: any, contentType: string): mixed => {
  return JSON.stringify(body)
}

// $FlowFixMe
export default new ApiClient(API_URL)



// WEBPACK FOOTER //
// ./src/api/client.js